import XEUtils from "xe-utils";
import httpManager from "../../util/common";
import {entityOaid, reportYear} from "../../util/util";

let execution_detail = {
  name: 'execution-detail',
  // props: ['oaid'],
  data: () => {
    return {
      data: [],
      oaid: null,
      report_year: null,
      report_year_options: [],
      report_months: [],
      sort_column: 'reporting_period',
      sort_order: 'desc',
      industry_code: [],
      industry_code_options: [],
      loading: false,
      tableColumn: [
        // {type: 'seq', width: 50},
        {title: 'i18n.pollution.current_permit_id', field: 'current_permit_id', sortable: true},
        {title: 'i18n.pollution.emission_unit_name', field: 'company_name'},
        {title: 'i18n.pollution.location', field: 'location_county'},
        {title: 'i18n.pollution.industry', field: 'industry'},
        {title: 'i18n.common.report_period', field: 'reporting_period', sortable: true},
        {title: 'i18n.pollution.particulates_ton', field: 'particulates', sortable: true},
        {title: 'i18n.pollution.nox_ton', field: 'nox', sortable: true},
        {title: 'i18n.pollution.so2_ton', field: 'so2', sortable: true},
        {title: 'i18n.pollution.vocs_ton', field: 'vocs', sortable: true},
        {title: 'i18n.pollution.nh3-n_ton', field: 'ammonia_nitrogen', sortable: true},
        {title: 'i18n.pollution.codcr_ton', field: 'codcr', sortable: true},
        {title: 'i18n.pollution.total_phosphorus_ton', field: 'total_phosphorus', sortable: true, width: 160},
        {title: 'i18n.pollution.total_nitrogen_ton', field: 'total_nitrogen', sortable: true, width: 160}
      ],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
        align: 'center',
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      }
    }
  },
  methods: {
    industryCodeOnChange (value, selectedOptions) {
      this.industry_code = value
    },
    industryCodeFilter (inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    generateReportYearOptions () {
      let date = new Date()
      let year = Number(date.getFullYear())
      this.report_year = year
      this.report_year_options = []
      for (let i = 2017; i <= year; i++) {
        this.report_year_options.push({label: String(i) + '年', value: i})
      }
    },
    headerCellClickEvent ({ column, triggerResizable, triggerSort, triggerFilter }) {
      // 如果触发了列的其他功能按钮
      if (column.sortable && !(triggerResizable || triggerSort || triggerFilter)) {
        this.sort_column = column.property
        this.sort_order = column.order
        // $refs.xTable.sort('name', 'desc')
        this.getExecutionDetailData()
      } else if (column.sortable && triggerSort) {
        this.sort_column = column.property
        if (this.sort_order === 'desc') {
          this.sort_order = 'asc'
          column.order = 'asc'
        } else {
          this.sort_order = 'desc'
          column.order = 'desc'
        }
        this.getExecutionDetailData()
      }
    },
    clearExecutionDetailForm () {
      this.data = []
      this.industry_code=[]
      this.page.pageSize = 20
      this.page.currentPage = 1
      this.page.total = 0
      this.report_year = new Date().getFullYear()
    },
    searchExecutionDetailData () {
      this.getExecutionDetailData()
    },
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getExecutionDetailData()
    },
    changeOaid () {
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid = result
        self.getExecutionDetailData()
      })
    },
    getExecutionDetailData () {
      let self = this
      if (self.oaid) {
        self.data = []
        self.loading = true
        let params = new Map()
        params.set('oaid', self.oaid)
        params.set('sort_column', self.sort_column)
        params.set('sort_order', self.sort_order)
        params.set('report_months', self.report_months)
        if (self.industry_code.length > 0) {
          params.set('industry_code', self.industry_code.slice(-1)[0])
        }
        if (params.length === 0) {
          return
        }
        params.set('pagenum', self.page.currentPage)
        params.set('pagesize', self.page.pageSize)
        httpManager('pollution_entity_execution_detail', params, null, null, null)
          .then(response => {
            self.data = []
            if (response.data.data.length > 0) {
              response.data.data.forEach(function (value, index, array) {
                let item = value
                item['location_county'] = item['province'] + '-' + item['district'] + '-' + item['county']
              })
              self.data = response.data.data
            }
            let page = response.data.page
            self.page.total = page.total
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
      }
    }
  },
  mounted () {
    reportYear.esg_report_month().then(result => {
      this.industry_code_options = result.industry_code
    })
    this.generateReportYearOptions()
    this.changeOaid()
  },
  watch: {
    report_year: function () {
      if (!this.report_year) {
        this.report_year = new Date().getFullYear()
      }
      this.report_months = []
      for (let i = 1; i <= 12; i++) {
        this.report_months.push(String(this.report_year) + '-' + String(i).padStart(2, '0'))
      }
      this.getExecutionDetailData()
    },
    industry_code: function () {
      this.getExecutionDetailData()
    }
  }
}
export default execution_detail



// WEBPACK FOOTER //
// ./src/pollution/js/execution_detail.js